class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M10 6.5a2.5 2.5 0 0 0 5 0 .5.5 0 0 0-.053-.224l-2-4a.5.5 0 0 0-.605-.25L9.176 3.08a1.516 1.516 0 0 0-.676-.489V1h-1v1.592a1.497 1.497 0 0 0-.998 1.38l-3.16 1.054a.5.5 0 0 0-.29.25l-2 4A.5.5 0 0 0 1 9.5a2.5 2.5 0 0 0 5 0 .5.5 0 0 0-.053-.224L4.205 5.792l2.619-.873c.175.223.41.392.676.489V14H3v1h10v-1H8.5V5.408a1.498 1.498 0 0 0 .998-1.38l2.015-.672-1.46 2.92A.5.5 0 0 0 10 6.5ZM3.5 11a1.497 1.497 0 0 1-1.408-1h2.815A1.498 1.498 0 0 1 3.5 11Zm1.191-2H2.309L3.5 6.618 4.691 9ZM8 4.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM12.5 8a1.498 1.498 0 0 1-1.408-1h2.815A1.497 1.497 0 0 1 12.5 8Zm0-4.382L13.691 6h-2.382L12.5 3.618Z"></path></svg>';
  }
}
const e = "pi-scales-tipped";
customElements.get(e) || customElements.define(e, s);
export {
  s as default
};
